export enum BeneficiaryPendency {
	FIELDS_REQUIRED = 'FIELDS_REQUIRED',
	PENDENCY_WITH_HR = 'PENDENCY_WITH_HR',
	PROCESSING_IN_CARRIER = 'PROCESSING_IN_CARRIER',
	TO_BE_INACTIVATED = 'TO_BE_INACTIVATED',
}
